import React from 'react';
import { FaCheckCircle,FaFire } from 'react-icons/fa';
import { FaBellConcierge, FaPlus } from 'react-icons/fa6';
import { GiPartyFlags } from 'react-icons/gi';
import {  } from 'react-icons/md'; // Importa el ícono para la viñeta


export const List = ({ items, itemType }) => {
  if (!Array.isArray(items) || items.length === 0) {
    return <p>No hay {itemType}s disponibles.</p>;
  }

  return (
    <ul className="item-list">
      {items.map((item, index) => (
        <li key={index} className={`item ${itemType}`}>
        <div>
        {itemType === "serviciosComida" ? (
              <FaBellConcierge className="item-bullet icon-golden" />
            ) : itemType === "promocionesPaquete" ? (
              <FaFire className="item-bullet icon-red" />
            ) : itemType === "serviciosRecomendados" ? (
              <FaPlus className="item-bullet" />
            ) : (
              <FaCheckCircle className="item-bullet default-icon" />
          )}
        </div>
         
          
          <span className="item-text">
            {item && (item.nombre || item.name || item)}
          </span>
        </li>
      ))}
    </ul>
  );
  
};
